import { NavLink } from "react-router-dom";
import { Building2, Users } from "lucide-react";
import { cn } from "@/lib/utils";

const items = [
  { to: "/platform/tenants", label: "All Tenants", icon: Building2, end: true },
  { to: "/platform/tenants/users", label: "All Users", icon: Users, end: false },
];

export function TenantSubNav() {
  return (
    <div className="flex gap-1 border-b">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            cn(
              "flex items-center gap-2 border-b-2 px-3 py-2 text-sm transition-colors",
              isActive
                ? "border-primary text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground",
            )
          }
        >
          <item.icon className="h-4 w-4" />
          {item.label}
        </NavLink>
      ))}
    </div>
  );
}
